import { ImageWraper } from '@components/shared/wraper/ImageWraper'
import { cloudfrontPath } from '@utils/image'

type Props = {
  idx: number
}

export const PopularProgramCardBadge = ({ idx }: Props): JSX.Element => (
  <div className="w-[15.2vw] lg:w-[6.2vw]">
    <ImageWraper
      src={`${cloudfrontPath}/programs/icons/program-category/no${idx}.svg`}
      width={79}
      height={79}
      alt={`人気No.${idx}`}
    />
  </div>
)
